class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.toggleButtonMore = this.querySelector('.read-more-toggle-more');
    this.toggleButtonLess = this.querySelector('.read-more-toggle-less');
    this.content = this.querySelector('.read-more-content');

    this.maxHeight = parseInt(this.getAttribute('data-max-height')) || 200; // Hauteur maximale par défaut
    this.originalHeight = this.content.scrollHeight;

    if (this.originalHeight > this.maxHeight) {
      this.content.style.maxHeight = `${this.maxHeight}px`;
      this.toggleButtonMore.addEventListener('click', this.toggleReadMore.bind(this));
      this.toggleButtonLess.addEventListener('click', this.toggleReadMore.bind(this));
    } else {
      this.toggleButtonMore.style.display = 'none';
      this.toggleButtonLess.style.display = 'none';
    }
  }

  toggleReadMore() {
    if (this.content.style.maxHeight === 'none' || this.content.style.maxHeight === '') {
      this.content.style.maxHeight = `${this.maxHeight}px`;
      this.toggleButtonMore.style.display = 'flex';
      this.toggleButtonLess.style.display = 'none';
    } else {
      this.content.style.maxHeight = 'none';
      this.toggleButtonMore.style.display = 'none';
      this.toggleButtonLess.style.display = 'flex';
    }
  }
}

customElements.define('read-more', ReadMore);
